/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import BaseControl from 'shared/ui/components/form-components/BaseControl.vue';

const __vue_script__ = {
    name: 'RegistrationType',

    extends: BaseControl,

    props: {
        value: {
            type: String,
            default: 'public'
        },

        showWarning: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            tempValue: this.value
        };
    },

    methods: {
        setValue(event) {
            this.tempValue = event.target.value;

            if (this.value === this.tempValue) {
                return;
            }

            if (this.showWarning) {
                this.$modal.show('warning');
            } else {
                this.emit();
            }
        },

        emit() {
            this.$emit('input', this.tempValue);
            this.$modal.hide('warning');
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('control-decorator',{staticClass:"registration-type",attrs:{"errors":_vm.errors,"uid":_vm.uid,"warning":_vm.warning,"dependant":_vm.dependant}},[_c('label',{staticClass:"radio",class:{ selected: _vm.value === 'public' }},[_c('input',{attrs:{"type":"radio","value":"public","name":_vm.name,"disabled":_vm.disabled},domProps:{"checked":_vm.value === 'public'},on:{"input":_vm.setValue}}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('registration.configuration.reg_types.public.title')))]),_c('span',{staticClass:"desc"},[_vm._v(_vm._s(_vm.$t('registration.configuration.reg_types.public.desc')))])]),_c('label',{staticClass:"radio",class:{ selected: _vm.value === 'private' }},[_c('input',{attrs:{"type":"radio","value":"private","name":_vm.name,"disabled":_vm.disabled},domProps:{"checked":_vm.value === 'private'},on:{"input":_vm.setValue}}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('registration.configuration.reg_types.private.title')))]),_c('span',{staticClass:"desc"},[_vm._v(_vm._s(_vm.$t('registration.configuration.reg_types.private.desc')))])]),_c('label',{staticClass:"radio",class:{ selected: _vm.value === 'hybrid' }},[_c('input',{attrs:{"type":"radio","value":"hybrid","name":_vm.name,"disabled":_vm.disabled},domProps:{"checked":_vm.value === 'hybrid'},on:{"input":_vm.setValue}}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('registration.configuration.reg_types.hybrid.title')))]),_c('span',{staticClass:"desc"},[_vm._v(_vm._s(_vm.$t('registration.configuration.reg_types.hybrid.desc')))])]),(_vm.showWarning)?_c('modal',{attrs:{"name":"warning","classes":"small","height":"auto","click-to-close":false}},[_c('div',{staticClass:"modal-header"},[_c('a',{staticClass:"close",on:{"click":function($event){return _vm.$modal.hide('warning')}}}),_c('i18n',{attrs:{"tag":"h2","path":"registration.configuration.switch_type.title"}},[_c('span',[_vm._v(_vm._s(_vm.$t(("registration.configuration.reg_types." + _vm.tempValue + ".title"))))])])],1),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v(_vm._s(_vm.$t('registration.configuration.switch_type.message')))])]),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.$modal.hide('warning')}}},[_vm._v(_vm._s(_vm.$t('general.cancel')))]),_c('button',{staticClass:"btn primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.emit()}}},[_c('i18n',{attrs:{"tag":"span","path":"registration.configuration.actions.switch_type"}}),_c('span',[_vm._v(" "+_vm._s(_vm.$t(("registration.configuration.reg_types." + _vm.tempValue + ".title"))))])],1)])]):_vm._e()],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "RegistrationType.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__